import { useSpring, animated } from "react-spring";


const LoadingBlog = () => {
	const styles = useSpring({
		loop: true,
		from: { backgroundPosition: "100% 100%" },
		to: { backgroundPosition: "0% 0%" },
		config: { duration: 1000 }
	})

	return (
		<animated.div
			style={{
				width: "100%",
				height: "400px",
				background: `linear-gradient(270deg,
					#ffffff0f, #ffffff0f, #ffffff0f, #ffffff0f, #ffffff2f, #ffffff0f, #ffffff0f,#ffffff0f, #ffffff0f)`,
				...styles,
				backgroundSize: "400% 400%"
			}}
		/>
	)
}

export default LoadingBlog;